import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { DragDropContext } from "react-beautiful-dnd";
import PhotoEditingImage from "~/models/PhotoEditing/PhotoEditingImage";
import ReviewImage from "./ReviewImage";
import ReviewPhoto from "./ReviewPhoto";

@observer
class ReviewImages extends Component {
  constructor(props) {
    super(props);

    this.handleClearPhotoEditingSelection = this.handleClearPhotoEditingSelection.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener("click", this.handleClearPhotoEditingSelection);
  }

  componentWillUnmount() {
    document.body.removeEventListener("click", this.handleClearPhotoEditingSelection);
  }

  // eslint-disable-next-line react/sort-comp
  handleClearPhotoEditingSelection(event) {
    if (!event || !event.target) {
      return;
    }

    const { clearPhotoEditingPhotosSelectionCallback } = this.props;

    // if the click didn't happen on a Photo, Delete Photos Button, or a Modal (confirm modal) then clear all selection.
    if (!event.target.closest(".review-image, .delete-photos, .modals")) {
      clearPhotoEditingPhotosSelectionCallback();
    }
  }

  onDragEnd(result) {
    const { source, destination } = result;

    // Check if the photo was dragged into the void (a non droppable area)
    if (!destination) {
      return;
    }

    const { reorderPhotoCallback } = this.props;

    const { droppableId: sourceImageId, index: sourcePhotoIndex } = source;
    const { droppableId: destinationImageId, index: destinationPhotoIndex } = destination;

    reorderPhotoCallback({ sourceImageId, sourcePhotoIndex }, { destinationImageId, destinationPhotoIndex });
  }

  render() {
    const { photoEditingImages, togglePhotoEditingPhotoSelectionCallback } = this.props;

    return (
      <DragDropContext onDragEnd={result => this.onDragEnd(result)}>
        {photoEditingImages.map((photoEditingImage, index) => (
          <ReviewImage key={photoEditingImage.photoEditingImageId} photoEditingImage={photoEditingImage} index={index}>
            {photoEditingImage.photoEditingPhotos.map((photoEditingPhoto, photoIndex) => (
              <ReviewPhoto
                {...photoEditingPhoto}
                key={photoEditingPhoto.photoEditingPhotoId}
                index={photoIndex}
                togglePhotoEditingPhotoSelectionCallback={() =>
                  togglePhotoEditingPhotoSelectionCallback(photoEditingPhoto.photoEditingPhotoId)
                }
              />
            ))}
          </ReviewImage>
        ))}
      </DragDropContext>
    );
  }
}

ReviewImages.propTypes = {
  photoEditingImages: PropTypes.arrayOf(PropTypes.instanceOf(PhotoEditingImage)).isRequired,
  reorderPhotoCallback: PropTypes.func.isRequired,
  togglePhotoEditingPhotoSelectionCallback: PropTypes.func.isRequired,
  clearPhotoEditingPhotosSelectionCallback: PropTypes.func.isRequired,
};

export default ReviewImages;
